import { render, staticRenderFns } from "./ImageTypeFolder.vue?vue&type=template&id=275dcc58&scoped=true&"
import script from "./ImageTypeFolder.vue?vue&type=script&lang=js&"
export * from "./ImageTypeFolder.vue?vue&type=script&lang=js&"
import style0 from "./ImageTypeFolder.vue?vue&type=style&index=0&id=275dcc58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275dcc58",
  null
  
)

export default component.exports